import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
    getAdvertisementsList,
    getExamslistByAdvertisementId,
    getPostCriteriaByAdvertisementId
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getRecommendationCutOff } from "../../actions/interviewProcessActions";
import {
    getYearList,
    getMainsAdvertisements,
} from "../../../common/actions/commonActions";

const RecommendationCutOff = () => {
    const pdfRef = useRef(null);

    const { register, handleSubmit, errors } = useForm({
        mode: "onChange",
    });


    let { advertisementList, examList, postcriterialisting } = useSelector(
        (state) => state.postExamProcessObjectReducer,
        shallowEqual
    );
    let { yearList, getMainsAdvertisement } = useSelector(
        (state) => state.common,
        shallowEqual
    );
    let { getRecommendationCutOffList } = useSelector(
        (state) => state.interviewProcessReducer,
        shallowEqual
    );

    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedPostCriteria, setSelectedPostCriteria] = useState("");
    const [reloadItem, setReloadItem] = useState(true);
    const [saveButtonFlag, setSaveButtonFlag] = useState(true);
    const [confirmClicked, setConfirmClicked] = useState(false);
    const [printFlag, setPrintFlag] = useState(true);
    const [cutOffData, setCutOffData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("")
    const session = JSON.parse(sessionStorage.getItem("session"));
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(getYearList());
        setReloadItem(!reloadItem);
        onCancelButton();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (getRecommendationCutOffList.recommendationCategoryList) {
            setCutOffData(getRecommendationCutOffList.recommendationCategoryList);
        }
        else {
            setCutOffData([])
        }
    }, [getRecommendationCutOffList.recommendationCategoryList]);

    useEffect(() => {
        if (getRecommendationCutOffList.recommendationCategoryList) {
            setCutOffData(getRecommendationCutOffList.recommendationCategoryList);
        } else {
            setCutOffData([]);
        }
    }, [getRecommendationCutOffList.recommendationCategoryList]);

    useEffect(() => {
        setPrintFlag(cutOffData.length === 0);
    }, [cutOffData]);

    const onAdvertisementChange = (ele) => {
        setSelectedAdvertNo(ele);
        setSelectedExam("");
        setSelectedPostCriteria("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        examList.length = 0;
        cutOffData.length = 0;
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
        ele && dispatch(getExamslistByAdvertisementId(ele));
        setReloadItem(!reloadItem);
    };

    const onSelectYear = (ele) => {
        if (ele == "") {
            onCancelButton();
        } else {
            let selectedValue = ele;
            setSelectedYear(selectedValue);
            selectedValue && dispatch(getMainsAdvertisements(selectedValue));
            if (getMainsAdvertisement) {
                getMainsAdvertisement.length = 0;
            }
            if (examList) {
                examList.length = 0;
            }
            if (postcriterialisting) {
                postcriterialisting.length = 0;
            }
            setSaveButtonFlag(true);
            setCutOffData([]);
            setReloadItem(!reloadItem);
        }
    };

    const onExamChange = (ele) => {
        setSelectedExam(ele);
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        dispatch(getPostCriteriaByAdvertisementId(selectedAdvertNo));
        setReloadItem(!reloadItem);
        cutOffData.length = 0;
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
    };

    const onPostCriteriaChange = (ele) => {
        setSelectedPostCriteria(ele);
        setSaveButtonFlag(false);
        setConfirmClicked(false);
        setPrintFlag(false);
        setReloadItem(!reloadItem);
        cutOffData.length = 0;
        setReloadItem(!reloadItem);
    };

    const onCancelButton = () => {
        setSelectedAdvertNo("");
        setSelectedExam("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        setCutOffData([]);
        setReloadItem(!reloadItem);
        getMainsAdvertisement.length = 0;
        examList.length = 0;
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
    };

    const onSubmit = () => {
        dispatch(getRecommendationCutOff(selectedAdvertNo, selectedExam, selectedPostCriteria,setPrintFlag));
        setReloadItem(!reloadItem);
    };

    const genPdf = () => {
        let headerDiv =
            '<div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
            label.MPSC +
            "</h5><h5>" +
            getRecommendationCutOffList.examName +
            "</h5><h5>" +
            label.RECOMMENDATIONCUTOFF + " - " + getRecommendationCutOffList.postCriteriaName +
            "</h5></div>";
        const htmlContent = document.createElement("div");
        htmlContent.innerHTML = headerDiv;
        htmlContent.innerHTML += pdfRef.current.innerHTML;
        const examName = getRecommendationCutOffList.examName;

        const options = {
            margin: [0.8, 0.4, 0.8, 0.4],
            filename: "RecommendationCutOffList.pdf",
            image: { type: "jpeg", quality: 0.95 },
            html2canvas: { scale: 3, dpi: 300, letterRendering: true },
            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "portrait",
                compressPDF: true,
            },
        };

        html2pdf()
            .from(htmlContent)
            .set(options)
            .toPdf()
            .get("pdf")
            .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const textWidth =
                        (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
                        pdf.internal.scaleFactor;
                    const textX = pageWidth - textWidth - 1;
                    const textY = 0.8;
                    const currentDate = new Date();
                    const formattedDate = currentDate
                        .toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })
                        .split("/")
                        .join("/");
                    const dateWidth =
                        (pdf.getStringUnitWidth(formattedDate) *
                            pdf.internal.getFontSize()) /
                        pdf.internal.scaleFactor;
                    const dateX = pageWidth - dateWidth;
                    const dateY = 0.6;
                    pdf.setFontSize(8);
                    pdf.text(formattedDate, dateX, dateY);
                    pdf.text(`Page No. ${i}`, dateX, textY);

                    const ad = getRecommendationCutOffList.advertisementNo;
                    const headerText = `Advertisement No. ${ad}`;
                    const headerX = 0.4;
                    const headerY = 0.6;

                    pdf.setFontSize(8);
                    pdf.text(headerText, headerX, headerY);
                }

                pdf.save(`RecommendationCutOffList_${examName}.pdf`);
            });
    };

    const downloadPdf = () => {
        genPdf();
        setReloadItem(!reloadItem);
    };

    const groupByCategory = () => {
        const groupedData = {};
        cutOffData.forEach((item) => {
            const { category, subCategory, cutoff } = item;
            if (!groupedData[category]) {
                groupedData[category] = [];
            }
            groupedData[category].push({ subCategory, cutoff });
        });
        return groupedData;
    };

    const groupedCutOffData = groupByCategory();

    return (
        <div>
            <div className="row dashboardCards">
                <div className="col-md-12">
                    <form name="importForm" encType="multipart/form-data">
                        <div className="form-group importFromSection">
                            <div className="row">
                                <div className="form-group col-md-2">
                                    <label className="float-left">
                                        {commonLabels.selectYear}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedYear"
                                        value={selectedYear}
                                        //   ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSelectYear(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {yearList &&
                                            yearList.length > 0 &&
                                            yearList.map((element, index) => (
                                                <option>{element}</option>
                                                // <option key={index} value={element.id}>
                                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                // </option>
                                            ))}
                                    </select>
                                    {_.get("selectedYear.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="float-left">
                                        {commonLabels.SelectAdvertNo}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedAdvertiseNo1"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onAdvertisementChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {getMainsAdvertisement &&
                                            getMainsAdvertisement.length > 0 &&
                                            getMainsAdvertisement
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedAdvertiseNo1.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>

                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.SelectExam}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedExam"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onExamChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {examList &&
                                            examList.length > 0 &&
                                            examList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedExam.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>

                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.PostCriteria}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedPostCriteria"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onPostCriteriaChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {postcriterialisting &&
                                            postcriterialisting.length > 0 &&
                                            postcriterialisting
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedPostCriteria.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>
                            </div>

                            <div className="row">
                                <div className="form-group col-md-8">
                                    {(session.roleName == "superadmin" ||
                                        session.roleName == "secretary" ||
                                        session.roleName == "desk officer") && (
                                            <>
                                                {" "}
                                                <button
                                                    type="reset"
                                                    className="btn btn-secondary mr-2"
                                                    onClick={() => onCancelButton()}
                                                >
                                                    {commonLabels.BUTTON_CANCEL}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary mr-2"
                                                    disabled={saveButtonFlag}
                                                    onClick={handleSubmit((e) => {
                                                        onSubmit(e);
                                                        setConfirmClicked(true);
                                                    })}
                                                >
                                                    {commonLabels.BUTTON_VIEW}
                                                </button>
                                            </>
                                        )}
                                    {(session.roleName == "superadmin" ||
                                        session.roleName == "secretary") && (
                                            <button
                                                type="button"
                                                className="btn btn-primary mr-2"
                                                disabled={printFlag || !confirmClicked}
                                                onClick={() => {
                                                    downloadPdf();
                                                }}
                                            >
                                                {commonLabels.BUTTON_PRINT}
                                            </button>
                                        )}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>


            {selectedPostCriteria && cutOffData && cutOffData.length > 0 && (
                <div ref={pdfRef} className="answerKeyTable" id="cutOff">
                    <table className="table table-bordered text-center">
                        <thead className="thead-light bold-label">
                            <tr>
                                <th className="w-20">Category</th>
                                <th className="w-20 text-left">SubCategory</th>
                                <th className="w-20">CutOff Marks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getRecommendationCutOffList.recommendationCategoryList.map((categoryData, index) => (
                                categoryData.recommendationCutoffList.map((cutoffData, subIndex) => (
                                    <tr key={`${index}-${subIndex}`}>
                                        {subIndex === 0 && (
                                            <td rowSpan={categoryData.recommendationCutoffList.length} style={{ verticalAlign: "middle" }}>
                                                {categoryData.category}
                                            </td>
                                        )}
                                        <td className="text-left">{cutoffData.subCategory}</td>
                                        <td>{cutoffData.cutoff}</td>
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </table>

                </div>
            )}
        </div>
    );
};

export default RecommendationCutOff;
